import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackWebEvent } from '../../utils/analyticsTracker';

/**
 * ScrollToTop - Forces the window to the top on every route change.
 * Also disables the browser's built-in scroll restoration which
 * can override our scroll position.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Disable browser's automatic scroll restoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    trackWebEvent('page_view');
  }, [pathname]);

  return null;
};

export default ScrollToTop;
